import { useAuth } from './useAuth';
import {
  can,
  isAdmin,
  canManageMembers,
  canManageRoles,
  canManageAreas,
  canManageCompany,
  hasAreaAccess,
  getUserPermissions,
} from '../utils/permissions';

/**
 * Hook para verificar permissões do usuário
 */
export const usePermissions = () => {
  const { user } = useAuth();

  return {
    // Função genérica para verificar permissões
    can: permissionKey => can(user, permissionKey),

    // Verificações específicas
    isAdmin: () => isAdmin(user),
    canManageMembers: () => canManageMembers(user),
    canManageRoles: () => canManageRoles(user),
    canManageAreas: () => canManageAreas(user),
    canManageCompany: () => canManageCompany(user),
    hasAreaAccess: areaSlug => hasAreaAccess(user, areaSlug),

    // Obter todas as permissões
    getUserPermissions: () => getUserPermissions(user),

    // Dados do usuário para uso direto
    user,
  };
};

/**
 * Hook específico para verificar se pode gerenciar membros
 */
export const useCanManageMembers = () => {
  const { canManageMembers } = usePermissions();
  return canManageMembers();
};

/**
 * Hook específico para verificar se é admin
 */
export const useIsAdmin = () => {
  const { isAdmin } = usePermissions();
  return isAdmin();
};

/**
 * Hook específico para verificar acesso a área
 */
export const useHasAreaAccess = areaSlug => {
  const { hasAreaAccess } = usePermissions();
  return hasAreaAccess(areaSlug);
};
